// FROM & TOOO CODE

import React, { useCallback, useEffect, useState } from "react";
import Navbar from "../../components/Navbar/Navbar";
import i18next, { t } from "i18next";
import {
  Input,
  DatePicker,
  Select,
  Breadcrumb,
  AutoComplete,
  Image,
  Spin, // ⭐ Added Spin component for nested feedback layouts
} from "antd";
import {
  CloseOutlined,
  DoubleRightOutlined,
  LoadingOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { routes } from "../../Routes";
import plus from "../../assets/Images/plus.svg";
// import AddVendor from "./AddVendor";
import {
  createPurchaseOrder,
  getPayTerms,
  getPurchaseProducts,
  getVendors,
  updatePOImages,
} from "../../API  Functions/PurchaseFunctions";
import { useDispatch, useSelector } from "react-redux";
import ExpiryModal from "../../modals/ExpiryModal";
// import ProductTable from "./ProductTable";
import PurchasePayment from "../../modals/purchasePaymentModal";
import SuccessModal from "../../modals/Sucessmodal";
import BarcodeScanner from "react-barcode-reader";
import {
  InventorySearchonboard,
  InventorySearchonboardBarcode,
} from "../../API  Functions/InventoryFunctions";
import axiosInstance from "../../AxiosInstance";
import { toast } from "react-toastify";
import LoadingSpinner from "../../components/Loading";
// import UploadBillImage from "./uploadBillImage";
import { UserImageUpload } from "../../API  Functions/UserMangement";
import AddBarcode from "../../modals/AddBarcodeModal";
import dayjs from "dayjs";
import { getSubstores } from "../../API  Functions/ProfileFunctions";
import {
  createStockTransfer,
  searchSubstoreInventory,
} from "../../API  Functions/subStoreFunctions";
import StockTransferProductTable from "./Tables/stockTransferProcutTable";
import i18n from "../../i18n";
import { URLS } from "../../API/API endpoints";

const StockTransfer = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const [vendor, setVendor] = useState(null);
  const [billDate, setBillDate] = useState(null);
  const [billNumber, setBillNumber] = useState("");
  const [vat, setVat] = useState(0);
  const [vatNum, setVatNum] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [productList, setProductList] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [billDiscount, setBillDiscount] = useState(0);
  const [vatAmount, setVatAmount] = useState(0);
  const [showComponent, setShowComponent] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [paymentTerms, setPaymentTerms] = useState([]);
  const [value, setValue] = useState("");
  const [Productoptions, setProductoptions] = useState([]);
  const [billDiscountPer, setBillDiscountPer] = useState(0);
  const [billDiscountVal, setBillDiscountVal] = useState(0);
  const [totalVatVal, settotalVatVal] = useState(0);
  const [selectedPaymentTerm, setSelectedPaymentTerm] = useState(null);
  const [isDraft, setIsDraft] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isPayModalVisible, setIsPayModalVisible] = useState(false);
  const [orderId, setOrderId] = useState(0);
  const [requestProduct, setrequestProduct] = useState(false);
  const [loading, setLoading] = useState(false);
  const [substoresLoader, setSubstoresLoader] = useState(false); // ⭐ Added substores background loader state
  const [productsLoader, setProductsLoader] = useState(false); // ⭐ Added autocomplete dropdown background loader state
  const [barcodeLoader, setBarcodeLoader] = useState(false); // ⭐ Added barcode background spinner loader state
  const [base64Images, setBase64Images] = useState([]);
  const [addImage, setAddImage] = useState(false);
  const [imageUrls, setImageUrls] = useState([]);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [searchByShortCode, setSearchByShortCode] = useState(false);
  const [currentProductIndex, setCurrentProductIndex] = useState(null);
  const [savedExpiryData, setSavedExpiryData] = useState({});
  const [isOrderCreated, setIsOrderCreated] = useState(false); // New state to track if the order is created
  const [popup, setpopup] = useState(false);
  const [isBarcodeModalVisible, setIsBarcodeModalVisible] = useState(false);
  const [isAddBarcodeModalOpen, setIsAddBarcodeModalOpen] = useState(false);
  const [transferSalePrice, setTransferSalePrice] = useState(true);

  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );

  const location = useLocation();
  const { orderData } = location.state || {};

  const vendorData = useSelector((state) => state.form.vendor);
  const billDateData = useSelector((state) => state.form.billDate);
  const billNumberData = useSelector((state) => state.form.billNumber);
  const vatNumData = useSelector((state) => state.form.vatNum);
  const productListData = useSelector((state) => state.form.productList);
  const [isFileValid, setFileValid] = useState(true);

  const [subStores, setSubStores] = useState([]);
  const [selectedSubStore, setSelectedSubStore] = useState(null);
  const masterStore = useSelector((state) => state.login.masterStore);
  const [fromStore, setFromStore] = useState(masterStore || null);
  const [searching, setSearching] = useState(false);

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const debounce = (func, delay) => {
    let timer;
    return function (...args) {
      const context = this;
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(context, args), delay);
    };
  };

  const isSaveDisabled = !selectedSubStore || productList.length === 0;

  useEffect(() => {
    if (masterStore) {
      getSubStoresData();
    }
  }, [masterStore]);

  const getSubStoresData = () => {
    setSubstoresLoader(true);
    getSubstores(masterStore?.store_id)
      .then((res) => {
        console.log("Substores Res", res);
        setSubStores(res?.response?.filter((item) => item.active) || []);
      })
      .catch((err) => {
        console.error("Error fetching substores:", err);
        setSubStores([]);
      })
      .finally(() => {
        setSubstoresLoader(false);
      });
  };

  const handleProductChange = (index, key, value) => {
    const updatedProductList = [...productList];

    if (key === "purchaseQty") {
      value = parseFloat(value) || 0;
    }

    updatedProductList[index][key] = value;

    setProductList(updatedProductList);

    const purchaseQty = updatedProductList[index]?.purchaseQty || 0;

    const prodSalePrice = updatedProductList[index]?.salesPrice;

    setProductList(updatedProductList);
  };

  const debouncedSearch = useCallback(
    debounce((value) => {
      if (value.length >= 3) {
        setProductsLoader(true);
        getPurchaseProducts(user_id, value, 10, 0)
          .then((res) => {
            console.log("EEEEEEEEE", res);

            if (res?.result && res.result.length > 0) {
              const products = res.result;
              setProductoptions(products);
            } else if (
              res?.result?.status_code === 400 &&
              res?.result?.status === "Does Not Found any Product"
            ) {
              toast.error(t("Product not found"));
            } else {
              setProductoptions([]);
            }
          })
          .catch(() => {
            setProductoptions([]);
          })
          .finally(() => {
            setProductsLoader(false);
          });
      } else {
        setProductoptions([]);
      }
    }, 1000),
    []
  );

  const handleProductSelect = (value) => {
    const selectedProduct = Productoptions.find(
      (product) => product.name === value
    );

  if (selectedProduct?.hamper_id && Array.isArray(selectedProduct?.hamper_items)) {
    const hasOutOfStockItem = selectedProduct?.hamper_items.some(
      (item) => Number(item.qty_available) <= 0
    );

    if (hasOutOfStockItem) {
      toast.error(
        `${selectedProduct?.name} cannot be transferred as its products do not have enough quantity`
      );
      return;
    }
  }


    if (selectedProduct) {
      if (!selectedProduct.barcode) {
        setSelectedProduct(selectedProduct);
        setSelectedProductId(selectedProduct.prod_id);
        setIsBarcodeModalVisible(true);
        return;
      }
    }

    if (selectedProduct) {
      const isDuplicate = productList.some(
        (product) => product?.hamper_id ? product?.hamper_id === selectedProduct?.hamper_id : product?.prod_id === selectedProduct?.prod_id
      );

      if (isDuplicate) {
        toast.error(`${selectedProduct.name} is already in the list.`);
        return;
      }

      const productWithQty = {
        ...selectedProduct,
        purchaseQty: 0,
        salesPrice: selectedProduct?.sale_price,
        is_update_cp_sp:true
      };
      setSelectedProduct(productWithQty);
      setProductList([...productList, productWithQty]);
      setSearchValue("");
      setValue("");
    }
  };

  const handleDeleteProduct = (index) => {
    const updatedProductList = [...productList];
    updatedProductList.splice(index, 1);
    setProductList(updatedProductList);
  };

  const handleCancel = () => {
    setProductList([]);
    setProductoptions([]);
    setSearchValue("");
    setValue("");
    setIsDraft(false);
    setCurrentProductIndex("");
  };

  const handleSavePurchaseOrder = async () => {
    for (const product of productList) {
      if (product.purchaseQty <= 0) {
        toast.error(t("Transfer Quantity cannot be 0."));
        return;
      }
      if (product.purchaseQty > product.parent_store_stock) {
        toast.error(
          t("Transfer Quantity cannot be more than Current Inventory") +
            ` (${
              i18next.language === "ar"
                ? fromStore?.store_name_ar
                : fromStore?.store_name
            })`
        );
        return;
      }
       if (
    !product.parent_store_cost_price ||
    product.parent_store_cost_price <= 0 ||
    !product.parent_store_sale_price ||
    product.parent_store_sale_price <= 0
  ) {
    toast.error(
      t(
        "Stock transfer is not allowed when Cost Price or Sale Price is zero. Please update the prices first."
      )
    );
    return;
  }
    }

    const payload = {
      parent_store_id: fromStore?.store_id,
      child_store_id: selectedSubStore?.store_id,
      status: "Draft",
      lines: productList.map((product) => ({
        product_id: product?.hamper_id ? false : product?.prod_id,
        ...(product?.hamper_id && {hamper_id:product?.hamper_id}),
        sale_price:product.parent_store_sale_price ?? 0,
        cost_price:product.parent_store_cost_price ?? 0,
        parent_company_stock: product.parent_store_stock ?? 0,
        child_company_stock: product.child_store_stock ?? 0,
        transfer_quantity: product.transfer_quantity ?? 0,
        is_update_cp_sp : transferSalePrice,
      })),
    };

    setLoading(true);
    try {
      const response = await createStockTransfer(payload);

      if (response?.result?.status_code === 200) {
        toast.success(t(response.result.status));
        setOrderId(response.result.transfer_id);
        setProductList([]);
        setProductoptions([]);
        setSearchValue("");
        setValue("");
        setIsDraft(false);
      } else {
        toast.error(
          t(response?.result?.status || "Failed to create stock transfer")
        );
      }
    } catch (error) {
      console.error("Failed to create stock transfer:", error);
      toast.error(t("Something went wrong while creating stock transfer."));
    } finally {
      setLoading(false);
    }
  };

  const handleclose = () => {
    setProductList([]);
    setIsOrderCreated(false);
    setLoading(false);
  };

  const searchProduct = async (value) => {
    setBarcodeLoader(true);
    try {
      let res = await InventorySearchonboardBarcode(value);

      if (res.result && Array.isArray(res.result)) {
        const productResponse = res.result[0];

        if (productResponse.status_code === 400) {
          try {
            const fetchGtinResponse = await axiosInstance.post(
              "/fetch_gs1_data",
              {
                gtin: value,
              }
            );

            if (fetchGtinResponse.data && fetchGtinResponse.data.result) {
              const fetchedProduct = fetchGtinResponse.data.result;

              if (fetchedProduct.gtin) {
                navigate("/inventory/ProductRequest", {
                  state: {
                    fetchedProduct,
                  },
                });
              } else {
                setrequestProduct(true);
                setProductoptions([]);
                setValue("");
              }
            } else {
              setrequestProduct(true);
              setProductoptions([]);
              setValue("");
            }
          } catch (error) {
            console.error("Error fetching GS1 data:", error);
            setrequestProduct(true);
          }
        } else {
          const isDuplicate = productList.some(
            (product) => product.prod_id === productResponse.prod_id
          );

          if (isDuplicate) {
            setSearchValue("");
            setValue("");
            toast.error(`${productResponse.name} is already in the list.`);
            return;
          }

          const productWithQty = {
            ...productResponse,
            vat: 0,
            purchaseQty: 0,
            freeQty: 0,
            discount: 0,
            discountValue: 0,
            salesPrice: productResponse?.sale_price,
            totalValue: 0,
            includingVat: 0,
            effectivePrice: 0,
            profit: 0,
            is_update_cp_sp:true
          };
          setSelectedProduct(productWithQty);
          setProductList([...productList, productWithQty]);
          setSearchValue("");
          setValue("");
        }
      }
    } catch (err) {
      console.error("Error searching via barcode scanning:", err);
    } finally {
      setBarcodeLoader(false);
    }
  };

  const searchBarcodeResult = useCallback(
    debounce((value) => {
      searchProduct(value);
    }, 1000),
    []
  );

  const searchResult = useCallback(
    debounce(async (value) => {
      setSearching(true);
      setProductsLoader(true);
      try {
        let parent_store_id = fromStore?.store_id;
        let res = await searchSubstoreInventory(
          value,
          parent_store_id,
          selectedSubStore?.store_id
        );

        console.log("API Response:", res?.result);

        if (
          res.result?.status_code === 400 &&
          res.result?.status === "Does Not Found any Product"
        ) {
          toast.error(t("Product not found"));
        }

        if (res.result?.response && Array.isArray(res.result?.response)) {
          const productResponse = res.result?.response[0];
          if (productResponse.status_code === 400) {
            setProductoptions([]);
          } else {
            setProductoptions(res.result?.response || []);
            setrequestProduct(false);
          }
        } else {
          setProductoptions([]);
          setrequestProduct(false);
        }
      } catch (err) {
        console.error(err);
        setProductoptions([]);
      } finally {
        setSearching(false);
        setProductsLoader(false);
      }
    }, 1000),
    [selectedSubStore, masterStore]
  );

  const handleSearchShortCode = useCallback(
    debounce(async (value, subStoreId) => {
      setProductsLoader(true);
      try {
        let parent_store_id = fromStore?.store_id;
        let payload = {
          parent_store_id: parent_store_id,
          child_store_id: selectedSubStore?.store_id,
          short_code: value,
          lang: i18n.language == "ar" ? "ar_001" : "en_US",
        };

        const res = await axiosInstance.post(
          URLS.SEARCH_BY_SHORT_CODE_IN_STOCK_TRANSFER,
          payload
        );

        if (
          res?.data?.result?.status_code === 400 &&
          res?.data?.result?.status === "Does Not Found any Product"
        ) {
          toast.error(t("Product not found"));
        }

        if (
          res?.data?.result?.response &&
          Array.isArray(res?.data?.result?.response)
        ) {
          const productResponse = res?.data?.result?.response[0];
          if (productResponse.status_code === 400) {
            setProductoptions([]);
          } else {
            setProductoptions(res?.data?.result?.response || []);
            setrequestProduct(false);
          }
        } else {
          setProductoptions([]);
          setrequestProduct(false);
        }
      } catch (err) {
        console.error("Error searching short code:", err);
        setProductoptions([]);
      } finally {
        setProductsLoader(false);
      }
    }, 1000),
    [selectedSubStore, masterStore]
  );

  return (
    <div className="w-full flex flex-col md:h-full pb-2 overflow-y-auto  bg-[#F6F7F9]">
      <Navbar heading={t("Stock Transfer")} />
      <div className="mx-3 flex flex-col justify-center bg-[#F6F7F9]">
        {(loading || barcodeLoader) && <LoadingSpinner />}
        <div className="overflow-y-auto custom-scrollbar">
          <div className="my-5">
            {/* From + To Stores Row */}
            <div className="flex gap-6 w-1/2 mt-5">
              {/* FROM Store */}
              <div className="w-1/2">
                <label className="block font-medium">{t("From")}</label>
                <Select
                  style={{ width: "100%" }}
                  placeholder={t("Select From Store")}
                  className="h-10 mt-2"
                  value={fromStore?.store_id}
                  disabled={productList.length > 0 || substoresLoader}
                  loading={substoresLoader} // ⭐ Integrated substores loading spinner indicator
                  onChange={(value) => {
                    const selected =
                      value === masterStore?.store_id
                        ? masterStore
                        : subStores.find((store) => store.store_id === value);
                    setFromStore(selected);
                  }}
                  showSearch
                >
                  {selectedSubStore?.store_id !== masterStore?.store_id && (
                    <Select.Option value={masterStore?.store_id}>
                      {i18next.language === "ar"
                        ? masterStore?.store_name_ar
                        : masterStore?.store_name}
                    </Select.Option>
                  )}

                  {subStores
                    .filter(
                      (store) => store.store_id !== selectedSubStore?.store_id
                    )
                    .map((store) => (
                      <Select.Option
                        key={store.store_id}
                        value={store.store_id}
                      >
                        {i18next.language === "ar"
                          ? store.store_name_ar
                          : store.store_name}
                      </Select.Option>
                    ))}
                </Select>
              </div>

              {/* TO Store */}
              <div className="w-1/2">
                <label className="block font-medium">{t("To")}</label>
                <Select
                  style={{ width: "100%" }}
                  placeholder={t("Select To Store")}
                  className="h-10 mt-2"
                  disabled={productList.length > 0 || substoresLoader}
                  loading={substoresLoader} // ⭐ Integrated substores loading spinner indicator
                  value={selectedSubStore?.store_id}
                  onChange={(value) => {
                    const selected =
                      value === masterStore?.store_id
                        ? masterStore
                        : subStores.find((store) => store.store_id === value);

                    setSelectedSubStore(selected);
                  }}
                  showSearch
                >
                  {fromStore?.store_id !== masterStore?.store_id && (
                    <Select.Option value={masterStore?.store_id}>
                      {i18next.language === "ar"
                        ? masterStore?.store_name_ar
                        : masterStore?.store_name}
                    </Select.Option>
                  )}

                  {subStores
                    .filter((store) => store.store_id !== fromStore?.store_id)
                    .map((store) => (
                      <Select.Option
                        key={store.store_id}
                        value={store.store_id}
                      >
                        {i18next.language === "ar"
                          ? store.store_name_ar
                          : store.store_name}
                      </Select.Option>
                    ))}
                </Select>
              </div>
            </div>

            {/* Product Search Row */}
            <div className="flex justify-between mt-8 w-1/2">
              {selectedSubStore && (
                <div className="w-full flex">
                  <span className="relative w-8/12">
                    <AutoComplete
                      value={value}
                      style={{ width: "100%", height: "43px", outline: "none" }}
                      open={dropdownOpen}
                      loading={productsLoader} // ⭐ Connected products loader into input option panel layers
                      onDropdownVisibleChange={(open) => setDropdownOpen(open)}
                      options={Productoptions.map((prod) => ({
                        value: prod.name,
                        label: (
                          <div className="flex justify-between items-center">
                            <span>{prod.name}</span>
                            {productList.some(
                              (p) => p.hamper_id ? (p.hamper_id === prod.hamper_id) : (p.prod_id === prod.prod_id)
                            ) && (
                              <svg
                                width="14"
                                height="14"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#16A34A"
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <polyline points="20 6 9 17 4 12" />
                              </svg>
                            )}
                          </div>
                        ),
                        disabled: productList.some(
                          (p) => p?.hamper_id ? (p?.hamper_id === prod?.hamper_id) : (p?.prod_id === prod?.prod_id)
                        ),
                      }))}
                      filterOption={false}
                      onSearch={(val) => {
                        setValue(val);
                        if (searchByShortCode) {
                          if (val.length >= 1) {
                            handleSearchShortCode(val);
                          } else {
                            setrequestProduct(false);
                            setProductoptions([]);
                          }
                        } else {
                          if (val.length >= 2) {
                            searchResult(val);
                            setDropdownOpen(true);
                          } else {
                            setProductoptions([]);
                            setDropdownOpen(false);
                          }
                        }
                      }}
                      onSelect={(val) => {
                        handleProductSelect(val);
                        setValue("");
                        setTimeout(() => setDropdownOpen(true), 0);
                      }}
                    >
                      <Input
                        placeholder={
                          searchByShortCode
                            ? t("Search Short Code")
                            : t("search_product")
                        }
                        size="large"
                        style={{
                          borderColor: "#d9d9d9",
                          boxShadow: "none",
                        }}
                        suffix={
                          productsLoader ? (
                            <Spin size="small" />
                          ) : value ? (
                            <CloseOutlined
                              onClick={() => {
                                setValue("");
                                setDropdownOpen(true);
                              }}
                              style={{ cursor: "pointer" }}
                            />
                          ) : (
                            <SearchOutlined />
                          )
                        }
                      />
                    </AutoComplete>
                  </span>
                  <button
                    type="button"
                    disabled={productsLoader}
                    onClick={() => {
                      setValue("");
                      setProductoptions([]);
                      setSearchByShortCode(!searchByShortCode);
                    }}
                    className="h-[40px] px-3 mx-3 rounded-md border border-primaryBlue text-sm bg-white whitespace-nowrap"
                  >
                    {searchByShortCode
                      ? t("Search by Name")
                      : t("Search by Code")}
                  </button>
                </div>
              )}

              <BarcodeScanner
                onScan={(data) => {
                  setValue(data);
                  searchBarcodeResult(data);
                }}
                onError={(err) => {
                  console.error(err);
                }}
                facingMode="environment"
                className="absolute inset-y-0 right-0 me-4 pointer-events-none cursor-pointer z-10"
              />
            </div>

            {/* Action Buttons */}
            {productList && productList.length > 0 && (
              <div className="flex flex-row justify-end items-end ms-4 gap-2 mt-5 me-10">
                <div className="flex gap-x-2">
                {!isOrderCreated && (
                  <button
                    onClick={handleCancel}
                    className={`font-semibold w-36 h-10 text-sm border border-primaryBlue rounded-lg bg-white text-primaryBlue flex justify-center items-center gap-2`}
                    type="submit"
                  >
                    <p className="">{t("Cancel")}</p>
                  </button>
                )}
                {!isOrderCreated && (
                  <button
                    onClick={handleSavePurchaseOrder}
                    disabled={isSaveDisabled}
                    className={`font-semibold w-32 h-10 border rounded-lg bg-primaryBlue text-white text-sm flex justify-center items-center gap-2 ${
                      isSaveDisabled ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                    type="submit"
                  >
                    <p className="">{t("Save")}</p>
                  </button>
                )}
                </div>
              </div>
            )}

            {/* Product Table */}
            {productList && productList.length > 0 && (
              <StockTransferProductTable
                disabled={isOrderCreated}
                productList={productList}
                handleProductChange={handleProductChange}
                handleDeleteProduct={handleDeleteProduct}
                fromStoreName={
                  i18next.language === "ar"
                    ? fromStore?.store_name_ar
                    : fromStore?.store_name
                }
                subStoreName={
                  i18next.language === "ar"
                    ? selectedSubStore?.store_name_ar
                    : selectedSubStore?.store_name
                }
              />
            )}
          </div>

          {popup && (
            <SuccessModal
              onClose={() => {
                setpopup(false);
              }}
              message={` ${t("Purchase Order Created Successfully")}  `}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default StockTransfer;